import { formatDate } from 'helpers/utils'
import Image from 'snippets/image/image'

function ArticleCard({ article }) {
  return (
    <div className="article flex flex-col border-r border-b border-neutral-900">
      <a className="group relative overflow-hidden" href={article.url} aria-label={`Read more ${article.title}`}>
        <div className="aspect-4/3 w-full overflow-hidden relative white-overlay white-overlay-group-hover">
          <Image
            url={article.image}
            alt={article.title}
            width={477}
            height={358}
            sizes={[768, 1024]}
            imageClass="w-full h-full"
            className="h-full w-full"
            loading="lazy"
          />
        </div>
        <div className="pl-3 pt-4 pr-5 pb-5 lg:p-5">
          <div className="flex items-center gap-2 mb-1.5 text-xs text-neutral-700">
            {article.tags.length > 0 ? (
                <>
                  {article.tags[0]} <span>|</span>
                </>
              ) : null}{' '}
            {formatDate(article.updatedAt)}
          </div>
          <h3 className="text-xs font-extrabold uppercase text-neutral-900">{article.title}</h3>
        </div>
      </a>
    </div>
  )
}

export default ArticleCard
